/**
 * ADR-0185 Phase B — what a landed replan changed, attributed in the user's
 * terms: their own moves first (where each landed, its changeover repricing),
 * then what moved around them, then the totals — pinned to the plan the
 * Refined row showed before the replan. Never a silent repaint.
 */
import type { BoardProposalView } from "../../boardTypes.js";
import { replanAttribution } from "./refineMath.js";

export function ReplanStrip(props: { landed: BoardProposalView; baselineLabel: string; onDismiss: () => void }) {
  const a = replanAttribution(props.landed, props.baselineLabel);
  return (
    <div className="boardStrip boardStripReplan" role="status">
      <div className="boardStripReplanBody">
        <div>
          <strong>Your {a.yourMoves.length === 1 ? "move" : `${a.yourMoves.length} moves`}:</strong>
        </div>
        {a.yourMoves.map((line, i) => (
          <div key={i} className="boardStripReplanMove">{line}</div>
        ))}
        <div>{a.aroundThem}</div>
        <div className="muted">{a.totals} · compared against {a.baseline}</div>
      </div>
      <span className="boardStripActions">
        <button className="adminListAction" onClick={props.onDismiss}>Dismiss</button>
      </span>
    </div>
  );
}
